import React from 'react'
import dayjs from 'dayjs'
import { NumberFmt, measureUnit } from 'src/utils'
import { useTheme } from 'styled-components'
import * as S from '../styles'
import { SalesReceivementBatch } from '../../../ReceivementTypes'
import { dropdownOptions } from './ActionDropdown'
import { FieldDropdown } from 'src/components/FieldDropdown'

interface Props {
  batch: SalesReceivementBatch;
}

const WrongProductTableRow = ({ batch }: Props) => {
  const theme = useTheme()

  return (
    <S.TableBodyRow backgroundColor={theme.colors.white}>
      <S.TableBodyCell flex={1}>
        <NumberFmt value={batch.totalQuantity} sufix={measureUnit(batch.measureUnit.isKg)} />
      </S.TableBodyCell>
      <S.TableBodyCell flex={1}>
        <NumberFmt value={batch.damageQuantity} sufix={measureUnit(batch.measureUnit.isKg)} />
      </S.TableBodyCell>
      <S.TableBodyCell flex={1}>
        <NumberFmt value={batch.totalQuantity - batch.damageQuantity} sufix={measureUnit(batch.measureUnit.isKg)} />
      </S.TableBodyCell>
      <S.TableBodyCell flex={1}>
        {batch.expirationDate
          ? dayjs(batch.expirationDate).format('DD/MM/YYYY')
          : '---'}
      </S.TableBodyCell>
      <S.TableBodyCell flex={1}>{batch.damageType}</S.TableBodyCell>
      <S.TableBodyCell flex={1.5}>
        <FieldDropdown
          data-testid='type-input-wrong-product'
          value={dropdownOptions.REJECT_ALL}
          options={Object.values(dropdownOptions)}
          onChange={() => {}}
          disabled
          containerStyle={{ padding: 0 }}
          style={{
            border: 0,
            height: 22,
            backgroundColor: 'transparent',
            padding: 0,
            boxShadow: 'none',
            fontFamily: 'Work Sans',
            color: 'inherit',
            fontSize: 14,
          }}
        />
      </S.TableBodyCell>
      <S.TableBodyCell flex={1}>
        <S.QuantityWrapper>
          <S.Input
            aria-label='Quantidade a ser aceita do lote'
            data-testid='wrong-product-qty-input'
            value={0}
            type='text'
            error={false}
            onChange={() => {}}
            readOnly
          />
        </S.QuantityWrapper>
      </S.TableBodyCell>
    </S.TableBodyRow>
  )
}

export { WrongProductTableRow }
